import React from 'react';
import PropTypes from 'prop-types';
import ShortId from 'shortid';

import HeadingActions from '../../components/HeadingActions';

export const PageLinks = (props) => {
  return (
    <HeadingActions
      key={ShortId.generate()}
      showPath={`/request-information/${props.serviceRequestId}`}
      historyPath={`/request-information-history/${props.serviceRequestId}`}
      discussion={{
        ...props.discussion,
        iconOnly: true,
        serviceRequestId: props.serviceRequestId
      }}
      discussionPath={props.discussionPath}
    />
  );
};

PageLinks.propTypes = {
  serviceRequestId: PropTypes.string,
  discussion: PropTypes.object,
  discussionPath: PropTypes.string
};
